import React from 'react';
import { Col, Form } from 'react-bootstrap';

/*
 * Periodo dei calendari Prenotazioni di lezioni e impianti (29/10/2026, TASK #14): al posto della data fissa
 * due campi «Dal» e «Al», uno o più giorni. Il server risponde un giorno alla volta, quindi si legge un giorno
 * per volta e ogni riga porta la sua data. Al massimo MAX_GIORNI giorni per ricerca.
 */
export const MAX_GIORNI = 31;

const isoDi = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** Oggi (AAAA-MM-GG), nell'ora del browser. */
export const oggiISO = () => isoDi(new Date());

/** Il giorno (AAAA-MM-GG) spostato di n giorni, a mezzogiorno per non sbagliare col cambio dell'ora. */
export const piuGiorni = (giorno, n) => {
	const [a, m, g] = giorno.split('-').map(Number);
	return isoDi(new Date(a, m - 1, g + n, 12));
};

/** I giorni dal primo all'ultimo, estremi compresi, al massimo MAX_GIORNI. */
export const giorniDelPeriodo = (dal, al) => {
	if (!dal) return [];
	const fine = al && al >= dal ? al : dal;
	const giorni = [];
	for (let g = dal; g <= fine && giorni.length < MAX_GIORNI; g = piuGiorni(g, 1)) giorni.push(g);
	return giorni;
};

/** «23/10/2026» da «2026-10-23». */
export const giornoItaliano = (giorno) => {
	const [a, m, g] = String(giorno).split('-');
	return g && m && a ? `${g}/${m}/${a}` : String(giorno);
};

/**
 * Il nuovo periodo dopo aver cambiato uno dei due campi: «Al» non resta prima di «Dal» (un «Al» prima di
 * «Dal» vale come un giorno solo) e il periodo non supera MAX_GIORNI giorni.
 */
export const nuovoPeriodo = ({ dal, al }, campo, valore) => {
	if (!valore) return { dal, al };
	if (campo === 'dal') {
		const massimo = piuGiorni(valore, MAX_GIORNI - 1);
		return { dal: valore, al: al < valore ? valore : al > massimo ? massimo : al };
	}
	if (valore < dal) return { dal: valore, al: valore };
	const massimo = piuGiorni(dal, MAX_GIORNI - 1);
	return { dal, al: valore > massimo ? massimo : valore };
};

/**
 * Legge il calendario di ogni giorno del periodo: `leggiGiorno(giorno)` restituisce l'elenco di quel giorno.
 * Ogni elemento esce con la sua `date`. Un giorno che non si legge resta vuoto, gli altri si vedono.
 */
export const calendarioDelPeriodo = async (dal, al, leggiGiorno) => {
	const perGiorno = await Promise.all(
		giorniDelPeriodo(dal, al).map(async (giorno) => {
			try {
				const res = await leggiGiorno(giorno);
				return (Array.isArray(res) ? res : []).map((el) => ({ ...el, date: giorno }));
			} catch (e) {
				console.error(e);
				return [];
			}
		}),
	);
	return perGiorno.flat();
};

/** I due campi «Dal» e «Al» nella riga dei filtri. */
export const CampiPeriodo = ({ periodo, onCambia, altezza }) => (
	<>
		<Col xs="auto" className="mb-2">
			<Form.Label htmlFor="periodo-dal">Dal</Form.Label>
			<Form.Control id="periodo-dal" type="date" value={periodo.dal} size="sm" style={{ minWidth: 160, height: altezza }}
				onChange={(e) => onCambia(nuovoPeriodo(periodo, 'dal', e.target.value))} />
		</Col>
		<Col xs="auto" className="mb-2">
			<Form.Label htmlFor="periodo-al">Al</Form.Label>
			<Form.Control id="periodo-al" type="date" value={periodo.al} min={periodo.dal} max={piuGiorni(periodo.dal, MAX_GIORNI - 1)}
				size="sm" style={{ minWidth: 160, height: altezza }}
				onChange={(e) => onCambia(nuovoPeriodo(periodo, 'al', e.target.value))} />
		</Col>
	</>
);
